import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AuthService } from "../../shared/services/auth.service";
const Swal = require("sweetalert2");

@Component({
  selector: "app-configuracoes",
  templateUrl: "./configuracoes.component.html",
  styleUrls: ["./configuracoes.component.scss"],
})
export class ConfiguracoesComponent implements OnInit {
  public configForm: FormGroup;
  public loading: boolean = false;
  public copiando: boolean = false;
  public userData: any = null;
  public cpf_cnpjMask = "000.000.000-00";

  mascararCpfCnpj(valor: string): string {
    let cleanedValue = valor.replace(/\D/g, "");

    if (cleanedValue.length <= 11) {
      // CPF
      if (cleanedValue.length <= 3) {
        return cleanedValue;
      } else if (cleanedValue.length <= 6) {
        return cleanedValue.replace(/^(\d{3})/, "$1.");
      } else if (cleanedValue.length <= 9) {
        return cleanedValue.replace(/^(\d{3})(\d{3})/, "$1.$2.");
      } else {
        return cleanedValue.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-");
      }
    } else {
      // CNPJ
      if (cleanedValue.length <= 2) {
        return cleanedValue;
      } else if (cleanedValue.length <= 5) {
        return cleanedValue.replace(/^(\d{2})/, "$1.");
      } else if (cleanedValue.length <= 8) {
        return cleanedValue.replace(/^(\d{2})(\d{3})/, "$1.$2.");
      } else if (cleanedValue.length <= 12) {
        return cleanedValue.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2.$3/");
      } else {
        return cleanedValue.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})/,
          "$1.$2.$3/$4-"
        );
      }
    }
  }

  onCpfCnpjInput(event: any) {
    const input = event.target;
    const valor = input.value;
    const mascarado = this.mascararCpfCnpj(valor);
    this.configForm.get("cpf_cnpj")?.setValue(mascarado, { emitEvent: false });
  }

  constructor(private fb: FormBuilder, private authService: AuthService) {
    this.configForm = this.fb.group(
      {
        nome: ["", [Validators.required, Validators.maxLength(255)]],
        email: [
          "",
          [Validators.required, Validators.email, Validators.maxLength(200)],
        ],
        telefone: ["", [Validators.required]],
        cpf_cnpj: ["", [Validators.required]],
        rua: ["", [Validators.required]],
        numero: ["", [Validators.required]],
        bairro: ["", [Validators.required]],
        cidade: ["", [Validators.required]],
        senha: ["", [Validators.minLength(6)]],
        confirmarSenha: [""],
        pix: ["", [Validators.required]],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit() {
    this.carregarDadosUsuario();
  }

  passwordMatchValidator(form: FormGroup) {
    const senha = form.get("senha");
    const confirmarSenha = form.get("confirmarSenha");

    if (
      senha &&
      confirmarSenha &&
      senha.value &&
      confirmarSenha.value &&
      senha.value !== confirmarSenha.value
    ) {
      confirmarSenha.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }

    if (confirmarSenha && confirmarSenha.errors) {
      delete confirmarSenha.errors["passwordMismatch"];
      if (Object.keys(confirmarSenha.errors).length === 0) {
        confirmarSenha.setErrors(null);
      }
    }

    return null;
  }

  carregarDadosUsuario() {
    this.loading = true;
    this.authService.listarUsuario().subscribe({
      next: (res) => {
        this.userData = res;
        this.configForm.patchValue({
          nome: res.nome || "",
          email: res.email || "",
          telefone: res.representante?.telefone || "",
          cpf_cnpj: res.representante?.cpf_cnpj || "",
          rua: res.representante?.rua || "",
          numero: res.representante?.numero || "",
          bairro: res.representante?.bairro || "",
          cidade: res.representante?.cidade || "",
          pix: res.representante?.pix || "",
          senha: "",
          confirmarSenha: "",
        });
        setTimeout(() => {
          this.configForm.get("senha")?.setValue("");
          this.configForm.get("confirmarSenha")?.setValue("");
        }, 100);
        this.loading = false;
      },
      error: (err) => {
        this.showAlert("error", "Erro ao carregar dados do usuário.");
        this.loading = false;
      },
    });
  }

  atualizarUsuario() {
    if (!this.configForm.valid) {
      this.showAlert(
        "error",
        "Por favor, preencha todos os campos corretamente."
      );
      return;
    }
    const {
      nome,
      email,
      telefone,
      cpf_cnpj,
      rua,
      numero,
      bairro,
      cidade,
      senha,
      confirmarSenha,
      pix,
    } = this.configForm.value;
    const nomeAlterado = nome !== this.userData.nome;
    const emailAlterado = email !== this.userData.email;
    const senhaAlterada = senha && senha.trim() !== "";
    const dadosAtualizacao: any = {
      nome,
      email,
      telefone,
      cpf_cnpj,
      rua,
      numero,
      bairro,
      cidade,
      pix,
    };
    if (senhaAlterada) {
      if (senha !== confirmarSenha) {
        this.showAlert("error", "As senhas não coincidem.");
        return;
      }
      dadosAtualizacao.senha = senha;
    } else if (confirmarSenha && confirmarSenha.trim() !== "") {
      this.showAlert("error", "Por favor, preencha ambos os campos de senha.");
      return;
    }
    this.loading = true;
    this.authService.atualizarUsuario(dadosAtualizacao).subscribe({
      next: (res) => {
        this.showAlert("success", "Dados atualizados com sucesso!");
        const userStr = localStorage.getItem("user");
        if (userStr) {
          const user = JSON.parse(userStr);
          user.nome = res.usuario.nome;
          user.email = res.usuario.email;
          localStorage.setItem("user", JSON.stringify(user));
        }
        this.userData.nome = res.usuario.nome;
        this.userData.email = res.usuario.email;
        window.dispatchEvent(
          new CustomEvent("userDataUpdated", {
            detail: { nome: res.usuario.nome, email: res.usuario.email },
          })
        );
        this.configForm.patchValue({ senha: "", confirmarSenha: "" });
        this.loading = false;
      },
      error: (err) => {
        let mensagem = "Erro ao atualizar dados.";
        if (err.error && err.error.message) {
          mensagem = err.error.message;
        }
        this.showAlert("error", mensagem);
        this.loading = false;
      },
    });
  }

  copiarLink() {
    const link = `https://painel.japedido.com.br/plano?ref=${this.userData.ref_representante}`;

    this.copiando = true;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.showAlert("success", "Link copiado com sucesso!");
          setTimeout(() => {
            this.copiando = false;
          }, 2000);
        })
        .catch(() => {
          this.copiarLinkFallback(link);
        });
    } else {
      this.copiarLinkFallback(link);
    }
  }

  private copiarLinkFallback(link: string) {
    const textArea = document.createElement("textarea");
    textArea.value = link;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      this.showAlert("success", "Link copiado com sucesso!");
    } catch (err) {
      this.showAlert(
        "error",
        "Erro ao copiar link. Tente selecionar e copiar manualmente."
      );
    }

    document.body.removeChild(textArea);

    setTimeout(() => {
      this.copiando = false;
    }, 2000);
  }

  showAlert(
    icon: "success" | "info" | "error",
    title: string,
    description?: string
  ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: icon,
      title: title,
      text: description,
    });
  }
}
